import { useEffect, useState } from 'react'
import Axios from 'axios';
import { KeyValueObject } from '../types/shared';


interface AuthState {
  loading: boolean;
  isLoggedin: boolean;
  csrf: string;
  cash: number;
  currency: string;
  invoices: boolean;
  location: string;
  userCapabilities: string[];
  reports: KeyValueObject<any>[],
}
/**
 * authentication state hook
 */
export function useAuth() {

  const [auth, setAuth] = useState<AuthState>({
    loading: true,
    isLoggedin: false,
    csrf: '',
    cash: 0,
    currency: 'USD',
    invoices: false,
    location: 'am',
    reports: [],
    userCapabilities: [],
  });
  const source = Axios.CancelToken.source();
  useEffect(() => {
    const checkAuthState = async () => {
      let isLoggedin;
      let csrf = '';
      let location = 'am';
      let invoices = false;
      let cash = 0;
      let currency = 'USD';
      let reports = [];
      let userCapabilities = [];

      try {
        const { data } = await Axios.get('/api/auth/check', {
          cancelToken: source.token,
        });

        if (data.code === 'success') {
          isLoggedin = true;
          location = data.data?.location;
          invoices = data.data?.invoices;
          cash = data.data?.cash;
          currency = data.data?.currency;
          reports = data.data?.reports;
          userCapabilities = data.data?.userCapabilities;
        } else {
          isLoggedin = false;
        }
        csrf = data.csrf;
      } catch (error) {
        if (error.response && error.response.data && error.response.data.code) {
          csrf = error.response.data.csrf;
        }
        isLoggedin = false;
      }

      setAuth({
        ...auth,
        csrf,
        cash,
        currency,
        reports,
        invoices,
        location,
        loading: false,
        isLoggedin,
        userCapabilities,
      });
    }
    checkAuthState();
    return () => {
      source.cancel();
    }
  }, []);
  return [auth, setAuth] as const;
}